import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from '../contexts/AuthContext.jsx';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, requiredPermission, requiredAllPermissions }) => {
  const { currentUser, loading } = useAuth();
  let location = useLocation();
  
  // Logs de diagnóstico comentados para reduzir verbosidade
  // console.log(`━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`);
  // console.log(`🔐 [ProtectedRoute] DIAGNÓSTICO COMPLETO`);
  // console.log(`📍 Rota tentada: ${location.pathname}`);
  // console.log(`⏳ Loading: ${loading}`);
  // console.log(`👤 currentUser existe: ${!!currentUser}`);
  // console.log(`🎯 Permissão requerida: ${requiredPermission} (tipo: ${typeof requiredPermission})`);
  
  // ✅ AGUARDAR CARREGAMENTO COMPLETO ANTES DE VALIDAR PERMISSÕES
  if (loading) {
    // console.log(`⏳ [ProtectedRoute] AGUARDANDO carregamento de permissões...`);
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  
  // Verificar se usuário está autenticado
  if (!currentUser) {
    console.error(`❌ [ProtectedRoute] Usuário NÃO AUTENTICADO - redirecionando para /Login`);
    return <Navigate to="/Login" state={{ from: location }} />;
  }
  
  // console.log(`✅ [ProtectedRoute] Usuário autenticado: ${currentUser.email || currentUser.uid}`);
  
  // Verificar permissão específica se necessário
  if (requiredPermission) {
    const userPermissions = currentUser.rulesOwned || [];
    
    // console.log(`📋 [ProtectedRoute] Total de permissões do usuário: ${userPermissions.length}`);
    // console.log(`🔍 [ProtectedRoute] Primeiras 20 permissões:`, userPermissions.slice(0, 20));
    // console.log(`🔍 [ProtectedRoute] Buscando permissão ${requiredPermission} no array...`);
    
    // Aceita uma única permissão ou uma lista (semântica "qualquer uma delas")
    const permissoesAceitas = Array.isArray(requiredPermission)
      ? requiredPermission
      : [requiredPermission];

    // Verificar se tem a permissão (aceita string ou number)
    const hasPermission = userPermissions.some(perm =>
      permissoesAceitas.some(req =>
        perm === req ||
        String(perm) === String(req) ||
        Number(perm) === Number(req)
      )
    );
    
    // console.log(`🔍 [ProtectedRoute] Permissão ${requiredPermission} encontrada: ${hasPermission}`);
    
    if (!hasPermission) {
      console.error(`❌ [ProtectedRoute] ACESSO NEGADO - Permissão ${requiredPermission} NÃO encontrada`);
      return <Navigate to="/unauthorized" state={{ from: location, requiredPermission }} />;
    }
  }

  // Verificar permissões obrigatórias (semântica "todas elas")
  if (requiredAllPermissions) {
    const userPermissions = currentUser.rulesOwned || [];
    const obrigatorias = Array.isArray(requiredAllPermissions)
      ? requiredAllPermissions
      : [requiredAllPermissions];

    const hasAll = obrigatorias.every(req =>
      userPermissions.some(perm =>
        perm === req ||
        String(perm) === String(req) ||
        Number(perm) === Number(req)
      )
    );

    if (!hasAll) {
      console.error(`❌ [ProtectedRoute] ACESSO NEGADO - Permissões obrigatórias ${JSON.stringify(obrigatorias)} NÃO encontradas`);
      return <Navigate to="/unauthorized" state={{ from: location, requiredAllPermissions: obrigatorias }} />;
    }
    
    // console.log(`✅ [ProtectedRoute] ACESSO PERMITIDO - Permissão ${requiredPermission} encontrada!`);
  }
  // else {
  //   console.log(`ℹ️ [ProtectedRoute] Nenhuma permissão específica requerida para esta rota`);
  // }
  
  return children;
};

export default ProtectedRoute;
